import apiClient from './apiClient'

export const postArticleExport = async (data) => await apiClient.post('/api/ArticleList', data)
